import { useAppSelector } from 'store/hooks';

export const useChatWidget = () => {
  const {
    actions: { setWindowVisibility, setIsInitialized },
    isChatWidgetWindowVisible,
    isInitialized,
  } = useAppSelector('chatWidget', ['isChatWidgetWindowVisible', 'isInitialized', 'actions']);

  return { isChatWidgetWindowVisible, isInitialized, setWindowVisibility, setIsInitialized };
};
